import { useContext, useState } from "react";
import './stylesSenha.css';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AlertMessage from "../../../Alert";
import { CadastroContext } from "../../../../contexts/CadastroContext";
import eyeOpen from '../../../../img/icon/Olho.svg';
import eyeClose from '../../../../img/icon/Olho Fechado.svg';

const AsoValidarSenha = () => {
    const [alert, setAlert] = useState<{ show: boolean; message: string; variant: string }>({ show: false, message: "", variant: "success" });
    const [buttonEnabled, setButtonEnabled] = useState<boolean>(false);
    const [passwords, setPasswords] = useState({ password1: '', password2: '' });
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { dbName } = useParams();
    let { password1, password2 } = passwords;

    const handleInput = (event: { target: { value: any; }; }) => {
        password1 = event.target.value;
        setPasswords({ ...passwords, password1 });
    };

    const handleInput2 = (event: { target: { value: any; }; }) => {
        const { value } = event.target;
        setButtonEnabled(value.trim() !== "");
        password2 = value;
        setPasswords({ ...passwords, password2 });
    };

    function handleSubmit() {
        if (!password1 || (password1 !== password2)) {
            password1 = '';
            password2 = '';
            return setAlert({ show: true, message: "Senhas não conferem!", variant: "danger" });
        }
        if (!isPasswordValid(password1)) {
            password1 = '';
            password2 = '';
            return setAlert({ show: true, message: "A senha é muito fraca!", variant: "danger" });
        }
        cadastro.password = password1;
        cadastro.passwordValidada = true;
        handleCadastroChange(cadastro);
        if (cadastro.isEmpresa && !cadastro.reaproveitamentoAso) {
            return navigate(`/aso/registro/validar-info-empresa/${cadastro.idConsulta}`);
        } else if (cadastro.reaproveitamentoAso) {
            return navigate('/aso/registro/validar-info-empresa');
        } else {
            if (location.pathname === `/aso/registro/validar-senha-aso/${dbName}`) {
                return navigate(`/aso/registro/validar-info-aso/${dbName}`);
            } else {
                return navigate(`/aso/registro/validar-info/${cadastro.idConsulta}/${dbName}`);
            }
        }
    }

    const isPasswordValid = (password: any) => {
        return password.length >= 8 && /[a-z]/.test(password) && /[A-Z]/.test(password) && /\d/.test(password) && /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="andes-card-senha center-card__body-senha center-card__body--padding-64-senha enter-email-card-senha password-overflow-hidden-mobile">
            <input type="hidden" />
            <h1 className="enter-card__title_senha password-margin-top-mobile">Digite sua Senha.</h1>
            <p className="enter-email-card__caption-senha password-small-size-mobile">"Certifique-se de que seja algo fácil de lembrar. Sua senha deve ter no mínimo 8 caracteres, incluindo uma letra minúscula, uma maiúscula, um número e um caractere especial."</p>
            <div className="andes-autocomplete-senha">
                <div className='andes-form-control-senha andes-form-control--textfield-senha enter-card__input-senha'>
                    <div className="andes-form-control__control-senha">
                        <input onChange={handleInput} className="andes-form-control__field-senha" type={showPassword ? "text" : "password"} />
                        <img className="olho"
                            src={showPassword ? eyeClose : eyeOpen}
                            onClick={togglePasswordVisibility}
                            style={{ marginRight: '10px' }}
                            alt="Toggle password visibility" />
                    </div>
                    <div className="andes-form-control__bottom-senha">
                        <span className="andes-form-control__message-senha password-small-height-mobile">Digite a Senha</span>
                    </div>
                </div>
                <div className="andes-dropdown-senha andes-dropdown--form-senha">
                    <div className="andes-dropdown__popover-senha">
                        <ul className="andes-list-senha andes-list--dropdown-senha andes-list--selectable-senha" role="listbox" aria-label="Digite seu e-mail"></ul>
                    </div>
                </div>
            </div>
            <div className="andes-autocomplete-senha">
                <div className='andes-form-control-senha andes-form-control--textfield-senha enter-card__input-senha'>
                    <div className="andes-form-control__control-senha">
                        <input onChange={handleInput2} className="andes-form-control__field-senha" type={showPassword ? "text" : "password"} />
                        <img className="olho"
                            src={showPassword ? eyeClose : eyeOpen}
                            onClick={togglePasswordVisibility}
                            alt="Toggle password visibility"
                            style={{ marginRight: '10px' }} />
                    </div>
                    <div className="andes-form-control__bottom-senha">
                        <span className="andes-form-control__message-senha password-small-height-mobile">Repita a senha</span>
                    </div>
                </div>
                <div className="andes-dropdown andes-dropdown--form-senha">
                    <div className="andes-dropdown__popover-senha">
                        <ul className="andes-list-senha andes-list--dropdown-senha andes-list--selectable-senha" role="listbox" aria-label="Digite seu e-mail"></ul>
                    </div>
                </div>
            </div>
            <button type="button" onClick={() => { handleSubmit() }}
                className={`andes-button-senha andes-button-enter-card__submit-senha andes-button--large-senha andes-button--loud-senha andes-button--disabled-senha andes-button--full-width-senha 
            ${buttonEnabled ? "" : "andes-button--disabled-senha"}`} style={{ borderRadius: '6px' }} disabled={!buttonEnabled}>
                <span>Continuar</span>
            </button>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}

export default AsoValidarSenha;
